type SearchType = "customerInfo" | "addressInfo";
type CustomerInfoSearchIdOptionType =
  | "buyerIds"
  | "buyerExemptionCertIds"
  | "addressIds";

// define the interfaces and state for data report under team
export interface ICustomerLookup {
  reportName: string;
  reportPurpose: string;
  reviewers: string[];
  isUserAgreed: boolean;
  searchType: SearchType;
  idInput: string;
  customerInfoSearchIdOption: CustomerInfoSearchIdOptionType;
  filesUploaded: File[];
  fileIds: string;
  isDataEncrypted: string;
  dueDate?: string;
}

export interface IMarketplaceSellerLookup {
  reportName: string;
  reportPurpose: string;
  reviewers: string[];
  isUserAgreed: boolean;
  sellerName: string;
  sellerTaxId: string;
  sellerId: string;
  dueDate?: string;
}

export interface ISellerInformationLookup {
  reportName: string;
  reportPurpose: string;
  reviewers: string[];
  isUserAgreed: boolean;
  marketplaceId: string;
  idInput: string;
  filesUploaded: File[];
  fileIds: string;
  dueDate?: string;
}

// define the interfaces and state for data report under audit
export interface ICustomerLookupConfigs {
  [key: string]: ICustomerLookup;
}

export interface IMarketplaceSellerLookupConfigs {
  [key: string]: IMarketplaceSellerLookup;
}

export interface ISellerInformationLookupConfigs {
  [key: string]: ISellerInformationLookup;
}

// define the DataCreate state interface
export interface IDataCreateState {
  customerLookup: ICustomerLookupConfigs;
  marketplaceSellerLookup: IMarketplaceSellerLookupConfigs;
  sellerInformationLookup: ISellerInformationLookupConfigs;
}

export const BLANK_CUSTOMER_LOOKUP_CONFIG: ICustomerLookup = {
  reportName: "",
  reportPurpose: "",
  reviewers: [],
  isUserAgreed: false,
  searchType: "addressInfo",
  idInput: "",
  customerInfoSearchIdOption: "buyerIds",
  filesUploaded: [],
  fileIds: "",
  isDataEncrypted: "Yes",
  dueDate: "",
};

export const BLANK_MARKETPLACE_SELLER_LOOKUP_CONFIG: IMarketplaceSellerLookup =
  {
    reportName: "",
    reportPurpose: "",
    reviewers: [],
    isUserAgreed: false,
    sellerName: "",
    sellerTaxId: "",
    sellerId: "",
    dueDate: "",
  };

export const BLANK_SELLER_INFORMATION_LOOKUP_CONFIG: ISellerInformationLookup =
  {
    reportName: "",
    reportPurpose: "",
    reviewers: [],
    isUserAgreed: false,
    marketplaceId: "",
    idInput: "",
    filesUploaded: [],
    fileIds: "",
    dueDate: "",
  };

/**
 * define the intial state for each type of report under team/audit
 */
export const TEAM_LEVEL_DATA_REPORT_KEY_NAME = "team";
export const INITIAL_CUSTOMER_LOOKUP_STATE: ICustomerLookupConfigs = {
  [TEAM_LEVEL_DATA_REPORT_KEY_NAME]: BLANK_CUSTOMER_LOOKUP_CONFIG,
};
export const INITIAL_MARKETPLACE_SELLER_LOOKUP_STATE: IMarketplaceSellerLookupConfigs =
  {
    [TEAM_LEVEL_DATA_REPORT_KEY_NAME]: BLANK_MARKETPLACE_SELLER_LOOKUP_CONFIG,
  };
export const INITIAL_SELLER_INFORMATION_LOOKUP_STATE: ISellerInformationLookupConfigs =
  {
    [TEAM_LEVEL_DATA_REPORT_KEY_NAME]: BLANK_SELLER_INFORMATION_LOOKUP_CONFIG,
  };

export const getBlankWorkflowConfig = (queryType: string) => {
  // switch query type to define the state name
  switch (queryType) {
    case "CUSTOMER_INFORMATION_LOOKUP":
      return BLANK_CUSTOMER_LOOKUP_CONFIG;
    case "CUSTOMER_INFORMATION_LOOKUP_BY_BRAAVOS":
      return BLANK_CUSTOMER_LOOKUP_CONFIG;
    case "BrazilMarketPlaceSellerLookup":
      return BLANK_MARKETPLACE_SELLER_LOOKUP_CONFIG;
    case "SellerInformationLookup":
      return BLANK_SELLER_INFORMATION_LOOKUP_CONFIG;
    default:
      return BLANK_CUSTOMER_LOOKUP_CONFIG;
  }
};
